import {defineField, defineType} from 'sanity'
import {richTextContent} from '../../../data/richText'

export default defineType({
  title: 'Settings',
  name: 'settings',
  type: 'document',
  fields: [
    defineField({
      title: 'Site Title',
      name: 'siteTitle',
      type: 'string',
    }),
    defineField({
      title: 'Phone',
      name: 'phone',
      type: 'string',
    }),
    defineField({
      title: 'Email',
      name: 'email',
      type: 'string',
    }),
    defineField({
      title: 'Hours',
      name: 'hours',
      type: 'string',
    }),
    defineField({
      title: 'Address',
      name: 'address',
      type: 'object',
      fields: [
        defineField({
          title: 'Street',
          name: 'street',
          type: 'string',
        }),
        defineField({
          title: 'Street 2',
          name: 'street2',
          type: 'string',
        }),
        defineField({
          title: 'City',
          name: 'city',
          type: 'string',
        }),
        defineField({
          title: 'State',
          name: 'state',
          type: 'string',
        }),
        defineField({
          title: 'Zip',
          name: 'zip',
          type: 'string',
        }),
        defineField({
          title: 'Country',
          name: 'country',
          type: 'string',
        }),
      ],
    }),
    defineField({
      title: 'Google maps URL',
      name: 'googleMapsUrl',
      type: 'url',
    }),
    defineField({
      title: 'Facebook URL',
      name: 'facebook',
      type: 'url',
    }),
    defineField({
      title: 'Youtube URL',
      name: 'youtube',
      type: 'url',
    }),
    defineField({
      title: 'Instagram URL',
      name: 'instagram',
      type: 'url',
    }),
    defineField({
      title: 'Copyright',
      name: 'copyright',
      description: 'You can add "{currentYear}" anywhere in the text to display the current year.',
      type: 'string',
    }),
    defineField({
      name: 'freeShippingInfo',
      title: 'Free shipping info',
      type: 'array',
      of: richTextContent,
      description:
        'This text will appear in a popup when users click the free shipping on product pages',
    }),
    defineField({
      name: 'shippingMethodDescription',
      title: 'Shipping Method Description',
      type: 'array',
      of: richTextContent,
      description: 'This text appears below the shipping methods once rates are calculated',
    }),
    defineField({
      name: 'internationalShipmentsDisclaimer',
      title: 'International Shipments Disclaimer',
      type: 'array',
      of: richTextContent,
      description:
        'This text appears above the Shipping Method Description only when an order is shipping outside the US',
    }),
    defineField({
      name: 'accessoriesConfiguratorLoadingMessage',
      title: 'Accessories Configurator Loading Message',
      type: 'string',
      description:
        'This text will show up as overlay on the Accessories Configurator while accessories are loading',
    }),
    defineField({
      name: 'orderConfirmationMessage',
      title: 'Order Confirmation Message',
      type: 'array',
      of: richTextContent,
      description: 'This text will appear on the thank you page below the order confirmation text',
    }),
    defineField({
      name: 'registration',
      title: 'Create Account form',
      type: 'object',
      fields: [
        defineField({
          name: 'successMessage',
          title: 'Success message',
          type: 'text',
          rows: 3,
          description:
            'Shown in the Create Account form once the account is created. Leave empty for the default message.',
        }),
        defineField({
          name: 'optInLabel',
          title: 'Email opt-in label',
          type: 'string',
          description:
            'Label of the offers-and-deals checkbox. Leave empty for "Get special offers and deals by email".',
        }),
      ],
    }),
  ],
  preview: {
    prepare() {
      return {
        title: 'Global Settings',
      }
    },
  },
})
